import React from "react";
import { connect } from "react-redux";
import FormRow from "./FormRow/FormRow";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
        workstreamList: store.workstream.List,
        project: store.project
    }
})

class Form extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { workstreamList, loggedUser, project } = this.props;
        const actionsAllowedRole = loggedUser.data.userRole < 3 || project.Selected.leadId === loggedUser.data.id;
        if (((this.props.type === "External" && project.Selected.typeId === 1) || this.props.type !== "External")) {
            return (
                <div class="memberFormContainer">
                    <div class="memberFormHeader">
                        {actionsAllowedRole && (
                            <h2 class="addNewUser">
                                <a onClick={this.props.onAddMember}>
                                    <i class="material-icons">add</i>
                                    <span>Add {this.props.title}</span>
                                </a>
                            </h2>
                        )}
                    </div>
                    <div class="memberFormBody container--scrollableTable">
                        <table>
                            <thead>
                                <tr class={`${this.props.members.length === 0 ? "noRecordsFound" : ""}`}>
                                    <th style={{ width: '21%' }}>Name</th>
                                    <th style={{ width: '21%' }}>Email</th>
                                    <th style={{ width: '15%' }}>Position</th>
                                    <th style={{ width: '18%' }}>User Role</th>
                                    <th style={{ width: '15%' }}>Status</th>
                                    {actionsAllowedRole && (
                                        <th style={{ width: '17%', borderBottomColor: 'transparent' }}>Actions</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.members.length > 0 && this.props.members.map(m => {
                                    let isWorkStreamLead = false;
                                    const user = m.user || {};
                                    if (workstreamList) {
                                        for (const ws of workstreamList) {
                                            if (isWorkStreamLead) {
                                                break;
                                            }
                                            isWorkStreamLead = ws.workstreamMembers.findIndex(
                                                wm => wm.id === m.id && wm.assign === 'responsible'
                                            ) > -1;
                                        }
                                    }
                                    return <FormRow
                                        member={{
                                            id: m.id,
                                            name: `${user['first-name'] || ''} ${user['last-name'] || ''}`.trim(),
                                            email: user.email,
                                            position: m.position || m.title || '',
                                            role: user.role,
                                            status: m.status,
                                            avatar: user.avatar,
                                            isActive: m['is-active'],
                                            isProjectLead: m['is-project-lead'],
                                            userType: user['user-type'],
                                            user: user
                                        }}
                                        isWorkStreamLead={isWorkStreamLead}
                                        actionsPermissions={actionsAllowedRole}
                                        onSelectMember={this.props.onSelectMember}
                                        onRemoveMember={this.props.onRemoveMember}
                                        onInviteMember={this.props.onInviteMember}
                                    />
                                })}
                                {this.props.members.length === 0 && (
                                    <tr class="noRecordsFound">
                                        <td colSpan={actionsAllowedRole ? 6 : 5}>
                                            <span>No records found</span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        return null;
    }
}

export default Form;